import { isString } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import config from 'trade-in/config/index.js';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { MEDIA_QUERIES } from '@sm360/widget-commons-general';
import { Vehicle } from '@sm360/widget-commons-vehicle';

import MediaQuery from 'react-responsive';

import 'trade-in/components/CanadianBlackBookEstimate/components/EstimateHeader/EstimateHeader.scss';

const imagesServer = config.source.image;

const EstimateHeader = ({ onEditVehicle, tradeInVehicle }) => {
    const vehicleName = LocaleService.t('TRADE_IN.VEHICLE_NAME', {
        year: tradeInVehicle.year,
        make: tradeInVehicle.make,
        model: tradeInVehicle.model,
        modelTrim: tradeInVehicle.trim,
        modelTrimStyle: tradeInVehicle.style,
    });

    function renderWithClassUtil(classParam) {
        const classUtil = isString(classParam) ? classParam : '';
        return (
            <div className="EstimateHeader">
                <div className="estimate-header--details">
                    <div className="estimate-header--title sr-text">
                        <p className="is-price">{LocaleService.t('TRADE_IN.TITLES.TOP_DOLLAR')}</p>
                        <h3 className="sr-subtitle-1">{LocaleService.t('TRADE_IN.SUBTITLES.ESTIMATE_RANGE')}</h3>
                    </div>

                    <div className={`estimate-header--description sr-text ${classUtil}`}>
                        <div className="estimate-header--line" data-test="trade-in.estimate-header.vehicle-name">
                            <icon className="icon-review" />
                            {vehicleName}
                        </div>
                        <div className="estimate-header--line" data-test="trade-in.estimate-header.vehicle-odometer">
                            {tradeInVehicle.odometer} {LocaleService.t('TRADE_IN.ODOMETER.SYMBOL')}
                        </div>
                        <div className="estimate-header--line" data-test="trade-in.estimate-header.edit">
                            <button type="button" className="sr-link" onClick={onEditVehicle}>
                                {LocaleService.t('TRADE_IN.ESTIMATE.MODIFY')}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="estimate-header--image">
                    <span className="powered-by is-uppercase is-light sr-disclaimer">
                        {LocaleService.t('TRADE_IN.ESTIMATE.POWERED_BY')}
                    </span>
                    <img
                        src={`${imagesServer}/images/widget/showroom/asset/canadian_black_book.png`}
                        alt="logo Canadian Black Book"
                    />
                </div>
            </div>
        );
    }

    // TODO: #refactor - #rhang
    // We do this to apply the class "is-mobile" to correctly format text size
    // according to viewport. The titles scales automatically but not the rest
    // of texts. To be remove when widget-styles allow to scale texts on
    // viewport size.
    return (
        <div>
            <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>{renderWithClassUtil('is-mobile')}</MediaQuery>
            <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>{renderWithClassUtil()}</MediaQuery>
        </div>
    );
};

EstimateHeader.propTypes = {
    onEditVehicle: PropTypes.func.isRequired,
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel).isRequired,
};

EstimateHeader.displayName = 'CanadianBlackBookEstimate.EstimateHeader';

export default EstimateHeader;



// WEBPACK FOOTER //
// ./src/components/CanadianBlackBookEstimate/components/EstimateHeader/EstimateHeader.jsx